/**
 * The dashboard's patient panel on its own page, for any patient.
 *
 * The dashboard shows it for the new-patient queue. The RETAIN patient screen
 * links here for "Review Treatment Plan" (?tab=plan) and "View Clinical Twin"
 * (?tab=twin), for patients who are already on a plan and so are not in that
 * queue. Same component, same data, so the two can never drift apart.
 */

import { useParams } from 'react-router-dom';
import { PatientWorkspace } from '../components/PatientWorkspace';

export function PatientWorkspacePage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return (
    <div className="-mx-4 -mt-4">
      <PatientWorkspace patientId={id} backTo="/patients" />
    </div>
  );
}
